<template>
  <div class="future-options">
    <p>
      <label
        v-if="!!label"
        for="other-delivery-dates"
      >{{ label }}</label>
      <select
        id="other-delivery-dates"
        ref="select"
        class="form-control"
        @change="dateSelected($event)"
      >
        <option
          value=""
          selected
          disabled
        />
        <select-option
          v-for="deliveryOption in deliveryOptions"
          :key="deliveryOption.value"
          :delivery-option="deliveryOption"
        />
      </select>
    </p>
  </div>
</template>

<script>
import SelectOption from '@/components/SelectOption.vue';

export default {
  name: 'OptionsSelect',
  components: {
    SelectOption
  },
  props: {
    label: {
      type: String,
      default: null
    },
    deliveryOptions: {
      type: Array,
      required: true
    }
  },
  methods: {
    i18n(key, values = null) {
      return this.$t(this.i18nPath(key), values);
    },
    i18nPath(key) {
      return `optionsSelect.${key}`;
    },
    resetSelect() {
      this.$refs.select.value = '';
    },
    dateSelected(e) {
      const select = e.currentTarget;
      const selection = select.options[select.selectedIndex];

      this.$emit('date-selected', selection);
      this.resetSelect();
    }
  }
};
</script>

<style lang="scss">
#core-availability {
  .future-options {
    label {
      font-weight: normal;
      margin: 0 4px 0 0;
    }

    .form-control {
      max-width: 190px;
    }

    p {
      margin-bottom: 0;
    }
  }
}
</style>
